module.exports = __webpack_public_path__ + "img/house_28.85791c18.jpg";